import { useContext } from 'react';
import { AuthContext } from '../utils/auth/authContext';

const useAuthContext = () => {
  const authContext = useContext(AuthContext);
  return authContext;
};

export default useAuthContext;
